/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'lv',
  Pagination: {
    items_per_page: '/ lappuse',
    jump_to: 'iet uz',
    jump_to_confirm: 'apstiprināt',
    page: '',
    prev_page: 'Iepriekšējā lapa',
    next_page: 'Nākamā lapaspuse',
    prev_5: 'Iepriekšējās 5 lapas',
    next_5: 'Nākamās 5 lapas',
    prev_3: 'Iepriekšējās 3 lapas',
    next_3: 'Nākamās 3 lapas'
  },
  DatePicker: {
    lang: {
      placeholder: 'Izvēlieties datumu',
      rangePlaceholder: ['Sākuma datums', 'Beigu datums'],
      locale: 'lv_LV',
      today: 'Šodien',
      now: 'Tagad',
      backToToday: 'Atpakaļ pie šodienas',
      ok: 'Ok',
      clear: 'Skaidrs',
      month: 'Mēnesis',
      year: 'Gads',
      timeSelect: 'Izvēlieties laiku',
      dateSelect: 'Izvēlieties datumu',
      monthSelect: 'Izvēlieties mēnesi',
      yearSelect: 'Izvēlieties gadu',
      decadeSelect: 'Izvēlieties desmit gadus',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Iepriekšējais mēnesis (PageUp)',
      nextMonth: 'Nākammēnes (PageDown)',
      previousYear: 'Pagājušais gads (Control + left)',
      nextYear: 'Nākamgad (Control + right)',
      previousDecade: 'Pēdējā desmitgadē',
      nextDecade: 'Nākamā desmitgade',
      previousCentury: 'Pagājušajā gadsimtā',
      nextCentury: 'Nākamajā gadsimtā'
    },
    timePickerLocale: {
      placeholder: 'Izvēlieties laiku'
    }
  },
  TimePicker: {
    placeholder: 'Izvēlieties laiku'
  },
  Calendar: {
    lang: {
      placeholder: 'Izvēlieties datumu',
      rangePlaceholder: ['Sākuma datums', 'Beigu datums'],
      locale: 'lv_LV',
      today: 'Šodien',
      now: 'Tagad',
      backToToday: 'Atpakaļ pie šodienas',
      ok: 'Ok',
      clear: 'Skaidrs',
      month: 'Mēnesis',
      year: 'Gads',
      timeSelect: 'Izvēlieties laiku',
      dateSelect: 'Izvēlieties datumu',
      monthSelect: 'Izvēlieties mēnesi',
      yearSelect: 'Izvēlieties gadu',
      decadeSelect: 'Izvēlieties desmit gadus',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Iepriekšējais mēnesis (PageUp)',
      nextMonth: 'Nākammēnes (PageDown)',
      previousYear: 'Pagājušais gads (Control + left)',
      nextYear: 'Nākamgad (Control + right)',
      previousDecade: 'Pēdējā desmitgadē',
      nextDecade: 'Nākamā desmitgade',
      previousCentury: 'Pagājušajā gadsimtā',
      nextCentury: 'Nākamajā gadsimtā'
    },
    timePickerLocale: {
      placeholder: 'Izvēlieties laiku'
    }
  },
  Table: {
    filterTitle: 'Filtrēšanas izvēlne',
    filterConfirm: 'OK',
    filterReset: 'Atiestatīt',
    selectAll: 'Atlasiet pašreizējo lapu',
    selectInvert: 'Pārvērst pašreizējo lapu'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Atcelt',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Atcelt'
  },
  Transfer: {
    searchPlaceholder: 'Meklēt šeit',
    itemUnit: 'vienumu',
    itemsUnit: 'vienumus'
  },
  Upload: {
    uploading: 'Augšupielāde...',
    removeFile: 'Noņemt failu',
    uploadError: 'Augšupielādes kļūda',
    previewFile: 'Priekšskatiet failu',
    downloadFile: 'Lejupielādēt failu'
  },
  Empty: {
    description: 'Nav datu'
  }
};
